export const GET_DAILY_STATS = 'GET_DAILY_STATS';
export const GET_DAILY_STATS_SUCCESS = 'GET_DAILY_STATS_SUCCESS';
export const GET_DAILY_STATS_FAIL = 'GET_DAILY_STATS_FAIL';

export const GET_STATS_FILTERS = 'GET_STATS_FILTERS';
export const GET_STATS_FILTERS_SUCCESS = 'GET_STATS_FILTERS_SUCCESS';
export const GET_STATS_FILTERS_FAIL = 'GET_STATS_FILTERS_FAIL';